class ProductTabs extends HTMLElement {
  constructor() {
    super();

    this.tab = this.querySelectorAll('.tab-title');
    this.tabContents = this.querySelector('.tabs-contents');
    this.tabContent = this.querySelectorAll('.tab-content');
    this.link = this.querySelectorAll('.toggleLink');
    this.readMore = this.querySelectorAll('[data-show-more-toogle]');
    this.tabClose = this.querySelectorAll('.pdViewTab-close');
    this.isVerticalPopup = this.dataset.vertical === 'sidebar';
    this.isVerticalSidebarMobile = this.dataset.verticalMobile === 'sidebar-mobile';

    for (let i = 0; i < this.tab.length; i++) {
      this.tab[i].addEventListener('click', this.tabActive.bind(this));
    }

    for (let i = 0; i < this.link.length; i++) {
      this.link[i].addEventListener('click', this.tabToggle.bind(this));
    }

    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-show-more-toogle]') || e.target.closest('[data-show-more-toogle]')) {
        this.readMoreReadLess(e);
      } else if (e.target.matches('.pdViewTab-close') || e.target.closest('.pdViewTab-close')) {
        this.productTabClose(e);

        if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
          this.handleVerticalPopupClose(e);
        }
      }
    });

    if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
      const overlay = document.querySelector('.background-overlay');
      overlay?.addEventListener('click', this.onBackgroundClick.bind(this));
    }

    // Evita crash quando #tab-description-mobile não existe em alguns produtos
    setTimeout(() => {
      if (window.innerWidth > 550) {
        const $thisContent = document.getElementById('tab-description-mobile');
        if (!$thisContent) return;

        const tabShowMore = $thisContent.querySelector('.tab-showMore');
        const maxHeight = parseInt(tabShowMore?.dataset?.desMax, 10);

        // Se não tem botão/tabShowMore, nada pra remover
        if (!tabShowMore || Number.isNaN(maxHeight)) return;

        const tabHeight = $thisContent.offsetHeight;
        if (tabHeight < maxHeight) {
          tabShowMore.remove();
        }
      }
    }, 0);
  }

  tabActive(event) {
    event.preventDefault();
    event.stopPropagation();

    const $this = event.currentTarget || event.target;
    const href = $this?.getAttribute('href');
    if (!href) return;

    const id = href.replace('#', '');
    const button_tab = document.querySelector('.an-horizontal-shaking');

    if (!$this.classList.contains('is-open')) {
      this.tab.forEach((el) => el.classList.remove('is-open'));

      $this.classList.add('is-open');
      this.tabContents?.classList.add('is-show');
      button_tab?.classList.add('open-tab-content');

      this.tabContent.forEach((el) => {
        if (el.getAttribute('id') === id) el.classList.add('is-active');
        else el.classList.remove('is-active');
      });
    }

    if ($this.classList.contains('open-tab-content')) {
      button_tab?.classList.remove('open-tab-content');
    }

    this.checkTabShowMore(id);
  }

  tabToggle(event) {
    event.preventDefault();
    event.stopPropagation();

    const $this = event.currentTarget;
    if (!$this) return;

    const $thisContent = $this.parentNode?.nextElementSibling;
    if (!$thisContent) return;

    if ($this.classList.contains('popup-mobile') && window.innerWidth <= 551) {
      if ($($thisContent).hasClass('is-show')) $($thisContent).removeClass('is-show');
      else $($thisContent).addClass('is-show');
    } else {
      if (window.innerWidth <= 551 && $this.classList.contains('show-mobile')) {
        $this.classList.remove('is-open');
        $this.classList.remove('show-mobile');
        $($thisContent).slideUp('slow');
      } else if ($this.classList.contains('is-open')) {
        $this.classList.remove('is-open');

        if ((this.isVerticalPopup && window.innerWidth > 550) || ($this.matches('.sidebar-mobile') && window.innerWidth <= 550)) {
          $thisContent.classList.remove('is-show');
          document.body.classList.remove('tab-popup-show');
        } else {
          $($thisContent).slideUp('slow');
        }
      } else {
        $this.classList.add('is-open');

        if ((this.isVerticalPopup && window.innerWidth > 550) || ($this.classList.contains('sidebar-mobile') && window.innerWidth <= 550)) {
          document.body.classList.add('tab-popup-sidebar-show');
          $thisContent.classList.add('is-show');
          document.body.classList.add('tab-popup-show');
        } else {
          $($thisContent).slideDown('slow');
        }
      }
    }
  }

  readMoreReadLess(event) {
    event.preventDefault();
    event.stopPropagation();

    const $this = event.target || event.target.closest('[data-show-more-toogle]');
    if (!$this) return;

    const href = $this.getAttribute('href');
    if (!href) return;

    const id = href.replace('#', '');
    const textShowMore = $this.getAttribute('data-show-more-text');
    const textShowLess = $this.getAttribute('data-show-less-text');

    const tabShowMoreWrap = $this.closest('.tab-showMore');
    const desMax = tabShowMoreWrap?.dataset?.desMax;

    const contentEl = document.getElementById(`${id}`);
    if (!contentEl) return;

    if ($this.classList.contains('is-less')) {
      tabShowMoreWrap?.classList.remove('is-less');
      $this.classList.remove('is-less');
      tabShowMoreWrap?.classList.add('is-show');
      $this.classList.add('is-show');
      if (textShowMore) $this.innerText = textShowMore;

      if (desMax) contentEl.style.maxHeight = `${desMax}px`;
      this.tabContents?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    } else {
      tabShowMoreWrap?.classList.remove('is-show');
      $this.classList.remove('is-show');
      tabShowMoreWrap?.classList.add('is-less');
      $this.classList.add('is-less');
      if (textShowLess) $this.innerText = textShowLess;

      contentEl.style.maxHeight = 'unset';
    }
  }

  productTabClose(event) {
    event.preventDefault();
    event.stopPropagation();

    this.tabContents?.classList.remove('is-show');

    this.tab.forEach((el) => {
      el.classList.remove('is-open');
      document.querySelector('.an-horizontal-shaking')?.classList.remove('open-tab-content');
    });

    this.tabContent.forEach((el) => {
      el.classList.remove('is-active');
      document.querySelector('.an-horizontal-shaking')?.classList.remove('open-tab-content');
    });

    if (window.innerWidth <= 551) {
      const $toggleContent = event.target.closest('.toggle-content');
      $toggleContent?.classList.remove('is-show');
    }
  }

  checkTabShowMore(id) {
    if (window.innerWidth > 550) {
      const $thisContent = document.getElementById(`${id}`);
      if (!$thisContent) return;

      const tabShowMore = $thisContent.querySelector('.tab-showMore');
      const maxHeight = parseInt(tabShowMore?.dataset?.desMax, 10);

      if (!tabShowMore || Number.isNaN(maxHeight)) return;

      const tabHeight = $thisContent.offsetHeight;
      if (tabHeight < maxHeight) tabShowMore.remove();
    }
  }

  onBackgroundClick(event) {
    // corrigido: faltava o ponto no selector
    if (event.target.closest('.toggle-content.is-show') != null) return;

    document.querySelector('.toggleLink.is-open')?.classList.remove('is-open');
    document.querySelector('.toggle-content.is-show')?.classList.remove('is-show');
    document.body.classList.remove('tab-popup-show');
  }

  handleVerticalPopupClose(event) {
    const icon = event.target;
    const toggleContent = icon?.closest('.toggle-content');
    const tabContent = icon?.closest('.tab-content');

    toggleContent?.classList.remove('is-show');
    tabContent?.querySelector('.toggleLink')?.classList.remove('is-open');
    document.body.classList.remove('tab-popup-show');
  }
}

customElements.define('product-tab', ProductTabs);
